import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import ImageUploader from "./ImgVideoUploaderCommon";
import ImgVideoUploaderCommon from "./ImgVideoUploaderCommon";
import { ContentsService } from "services/ContentsService";
import Box from "@mui/material/Box";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DeleteIcon from "@mui/icons-material/Delete";

import IconButton from "@mui/material/IconButton";
import { ConfirmModal } from "components";

const ContentThumbnail = ({
  courseData,
  setCourseData,
  showIcons,
  setShowIcons,
}: any) => {
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const handleCloseModal = () => setConfirmModalOpen(false);

  const [loading, setLoading] = useState(false);
  const handleFileSelect = async (file: File) => {
    setLoading(true);
    try {
      const uid = courseData.id; // Assuming the contentData has an id field

      // Upload the selected file and get the download URL
      const downloadURL = await ContentsService.uploadHandoutPicture(uid, file);
      // Update contentData with the new cover photo URL
      setCourseData((prevContentData: any) => ({
        ...prevContentData,
        coverPhotoUrl: downloadURL, // Update the cover photo URL in contentData
      }));
      // Ensure the `downloadURL` is valid and update `showIcons`
      if (downloadURL && downloadURL.length > 0) {
        setShowIcons((prevState: any) => ({
          ...prevState,
          contentthumbnail: true, // Ensure this matches the parent component's state key
        }));
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = () => {
    setConfirmModalOpen(true);
  };
  const handleConfirm = () => {
    setCourseData((prevContentData: any) => ({
      ...prevContentData,
      coverPhotoUrl: "",
    }));
    setShowIcons((prevState: any) => ({
      ...prevState,
      contentthumbnail: false,
    }));
    setConfirmModalOpen(false);
  };

  return (
    <Grid
      display={"flex"}
      gap={5}
      flexDirection={"column"}
      p={{ xs: 2, md: 5 }}
      mt={{ xs: 3, md: 0 }}
    >
      <Grid item xs={12} sm={8} md={6} lg={4}>
        <Typography variant="h6" gutterBottom sx={styleSheet.labelText}>
          Select an Image
        </Typography>
        {/* Check if there's a file in `coverPhotoUrl`, otherwise show the upload UI */}
        {courseData.coverPhotoUrl ? (
          <Box
            pl="8px"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              width: { xs: "321px", md: "563px" },
              border: "2px dashed #ccc",
              borderRadius: "8px",
              height: "51px",
            }}
          >
            <Box display="flex" alignItems="center">
              <InsertDriveFileIcon color="disabled" />
              <Typography
                variant="body2"
                fontSize={18}
                fontWeight={700}
                color="#595959"
              >
                {courseData.coverPhotoUrl.split("/").pop()} (Image)
              </Typography>
            </Box>
            <IconButton
              onClick={handleDelete}
              sx={{
                marginRight: 1,
                color: "#E10A0A",
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        ) : (
          <ImgVideoUploaderCommon
            onFileSelect={handleFileSelect}
            setShowIcons={setShowIcons}
            subTitle="Select an Image"
            modalTitle="Are you sure you want to delete the file?"
            modalSubtitle="Figma ipsum component variant main layer."
          />
        )}
      </Grid>
      <ConfirmModal
        title={"Are you sure you want to delete the section?"}
        subtitle={
          "Figma ipsum component variant main layer. Asset opacity rotate plugin line. Project pen frame share."
        }
        cancelText="Cancel"
        confirmText="Confirm"
        titleColor="#020303"
        isLoading={false}
        onCancel={handleCloseModal}
        onConfirm={handleConfirm}
        isConfirmModal={isConfirmModalOpen}
        warning="Warning"
      />
    </Grid>
  );
};

export default ContentThumbnail;

const styleSheet = {
  labelText: {
    fontWeight: 400,
    fontSize: "17px",
    color: "#000000",
  },
};
